<template>
    <div class="text-center">
      <v-dialog v-model="dialog" width="500"> 

        <v-card>
        <v-card-title class="text-h5 grey lighten-2">
            {{ item?'Editar Nominacion':'Registrar Nominacion' }} 
        </v-card-title>

        <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
                <p class="text-center black--text"> <b>Recuerde que</b> el valor ingresado debe ser unico </p>
                <div class="row">
                    <div class="col-xs-12 col-sm-6">
                        <v-text-field v-model.number="valor" type="number" step="0.01" :counter="10" :rules="valorRules" label="Valor" required></v-text-field>
                    </div>
                    <!-- <div class="col-xs-12 col-sm-6">
                        <v-select v-model="select" :items="items" :rules="[v => !!v || 'Item is required']" label="Moneda" required></v-select>
                    </div> -->
                </div>

                <v-progress-linear v-if="loading" indeterminate color="green darken-2"></v-progress-linear>

                <p class="text-center red--text"> {{ msg }} </p>

                <div class="text-center">
                  <v-btn :disabled="loading" tile color="success" class="mr-4" @click="registrar()" >
                    {{ item?'guardar cambios':'Registrar' }}
                  </v-btn>
                </div>

                <!-- <v-btn color="error" class="mr-4" @click="reset">
                    Reset Form
                </v-btn>

                <v-btn color="warning" @click="resetValidation" >
                    Reset Validation
                </v-btn> -->
            </v-form>
        </v-card-text> 
      </v-card>
  
        
      </v-dialog>
    </div>
  </template>

<script>
import xaxios from '@/xaxios';

export default {
  data () {
    return {
      dialog: false,
      valid: true,
      loading: false,
      valor: '',
      msg: '',
      valorRules: [
        v => !!v || 'requerido',
        v => (v && v > 0) || 'positivo',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
      item: null,
    }
  },

  methods: {
    openmodal(item=null){
        this.dialog = true; 
        this.valor = '';
        this.item = item;
        if(item) this.valor = item.valor;
    },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },

      async registrar(){
        this.msg = '';
        if(!this.$refs.form.validate()) return;
        this.loading = true;

        const url = `${process.env.VUE_APP_API_REST}/api/v1/esam/denominaciones`;
        const data = {
            valor: this.valor
        }
        if (this.item){
            data.id = this.item.id;
            const res = await xaxios.put(url,data).then(x=>x).catch(x=>x);
            if(res && res.data && res.data.data.id) {
                this.dialog = false;
                this.$emit('success')
            }
            else this.msgErr(res);
            
        }else{
            const res = await xaxios.post(url,data).then(x=>x).catch(x=>x);
            if(res && res.data && res.data.data.id) {
                this.dialog = false;
                this.$emit('success')
            }
            else this.msgErr(res);
            
        }
        
        this.loading = false;
      },

      msgErr(res){ 
        try{ this.msg = res.response.data.data; }
        catch(e){ this.msg = res }
        
      }
    },
}
</script>